import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'
import { startInstallPromptCapture } from './lib/pwaInstall'

// beforeinstallprompt can fire before any install surface mounts; catch it once.
startInstallPromptCapture()

// If a slow page showed index.html's stalled-boot notice and then arrived
// after all, take the notice (and any host it made) away before rendering.
document.querySelectorAll('[data-boot-stalled-host], [data-boot-stalled]').forEach(node => node.remove())

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
// The code started: index.html's stalled-boot notice stands down.
window.__fosBooted = true
